import { createAction, props } from '@ngrx/store';
import { PayOnAccountPaymentPreviewV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const paymentPreviewPaymentReferenceUpdated = createAction(
  '[Pay On Account Review Payment] Payment Preview Payment Reference Updated',
  props<{ payload: PayOnAccountPaymentPreviewV1Response }>(),
);
